export const CATEGORIES = ["Travel Guides", "Rental Tips", "Company News", "Sustainability"];

export const IMAGES = [
  "https://images.unsplash.com/photo-1611216373106-69aecc7e1f4f?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1569670380585-19bb0feec807?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1772460448884-4d5e30f1efce?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1760068670115-6d4e415b0c7a?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1634823929885-b12342dfc408?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1634823005888-11796723fd70?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1768360612035-8bf84c9fbc0a?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1621838399861-3323b17e1287?crop=entropy&cs=srgb&fm=jpg&q=85",
];

export const slugify = (t) => t.toLowerCase().replace(/[^a-z0-9\s-]/g, "").trim().replace(/\s+/g, "-").slice(0, 60);
export const sectionKey = () => `sec_${Math.random().toString(36).slice(2, 10)}`;
export const emptySection = () => ({ _key: sectionKey(), heading: "", paragraphsText: "", bulletsText: "" });
